import {TabClickEventHandler} from "../../../core/handlers/tab.click-event.handler";
import {ACTION_TYPES} from "../../../core/consts";
import {BOX_SCORES_WIDGET} from "../box-scores-widget-consts";
import {BoxScoresWidgetState} from "../models/box-scores-widget.state";

export class BoxScoresWidgetTabClickHandler extends TabClickEventHandler {
  state: BoxScoresWidgetState;
  type = ACTION_TYPES.tabChange;

  async action(params){
    super.action(params)

    this.state.isHomeTeamSelected = params?.index === BOX_SCORES_WIDGET.COMPETITORS.home;

    return params;
  }
}